TrelloModel = require 'models/internal/trello-model'
_ = require 'underscore'

module.exports = class Tag extends TrelloModel

  typeName: 'Tag'
  urlRoot: -> "#{ @getOrganization().url() }/tags"

  getOrganization: -> @collection.sourceModel



// WEBPACK FOOTER //
// ./app/scripts/models/tag.coffee